export default __webpack_public_path__ + "static/media/certificate.3cfd6984.png";